export var ErrorCode;
(function (ErrorCode) {
    // basic status from http status
    ErrorCode[ErrorCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    ErrorCode[ErrorCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ErrorCode[ErrorCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    ErrorCode[ErrorCode["NOT_FOUND"] = 404] = "NOT_FOUND";
    ErrorCode[ErrorCode["CONFLICT"] = 409] = "CONFLICT";
    ErrorCode[ErrorCode["REQUEST_ENTITY_TOO_LARGE"] = 413] = "REQUEST_ENTITY_TOO_LARGE";
    ErrorCode[ErrorCode["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    ErrorCode[ErrorCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    ErrorCode[ErrorCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    // common
    ErrorCode[ErrorCode["VALIDATION_FAILED"] = 1001] = "VALIDATION_FAILED";
    ErrorCode[ErrorCode["MULTIPLE_UNIQUE_CONSTRAINT_FAILED"] = 1002] = "MULTIPLE_UNIQUE_CONSTRAINT_FAILED";
    ErrorCode[ErrorCode["DUPLICATED_FAIL"] = 1003] = "DUPLICATED_FAIL";
    ErrorCode[ErrorCode["UNPROCESSABLE_FAIL"] = 1004] = "UNPROCESSABLE_FAIL";
    ErrorCode[ErrorCode["PRISMA_ERROR"] = 1005] = "PRISMA_ERROR";
    ErrorCode[ErrorCode["START_DATE_MUST_BEFORE_END_DATE"] = 1006] = "START_DATE_MUST_BEFORE_END_DATE";
    ErrorCode[ErrorCode["INVALID_SORT_FIELD"] = 1007] = "INVALID_SORT_FIELD";
    // budget
    ErrorCode[ErrorCode["BUDGET_AMOUNT_MUST_BE_POSITIVE"] = 2001] = "BUDGET_AMOUNT_MUST_BE_POSITIVE";
    ErrorCode[ErrorCode["CATEGORY_BUDGET_AMOUNT_MUST_BE_POSITIVE"] = 2002] = "CATEGORY_BUDGET_AMOUNT_MUST_BE_POSITIVE";
    ErrorCode[ErrorCode["CATEGORY_BUDGETS_EXCEED_OVERALL"] = 2003] = "CATEGORY_BUDGETS_EXCEED_OVERALL";
    ErrorCode[ErrorCode["OVERALL_BELOW_CATEGORY_SUM"] = 2004] = "OVERALL_BELOW_CATEGORY_SUM";
    // bank import
    ErrorCode[ErrorCode["BANK_IMPORT_NO_DATA"] = 3001] = "BANK_IMPORT_NO_DATA";
    // slip parsing
    ErrorCode[ErrorCode["SLIP_PARSE_FAILED"] = 4001] = "SLIP_PARSE_FAILED";
    ErrorCode[ErrorCode["ALIAS_INVALID"] = 1010] = "ALIAS_INVALID";
})(ErrorCode || (ErrorCode = {}));
//# sourceMappingURL=error-code.enum.js.map